import { ManifestListFilters } from "@/models/api/barcodeSystem/manifests/get";
import { ManifestResource } from "@/models/api/barcodeSystem/manifests/get";

export function defaultManifestFilters(): ManifestListFilters {
  return {
    id: null,
    manifestName: null,
    isViewable: true,
    isLocked: null,
    facilityCodes: null,
    actualFacilityCodes: null,
    deliveryDate: null,
    createdDate: null,
    lastUpdatedDate: null,
    isWillCallManifest: null,
    tripDays: null
    } as ManifestListFilters;
}

export function defaultManifest(): ManifestResource {
  return {
    id: null,
    manifestName: null,
    deliveryDate: null,
    isViewable: null,
    facilityCode: null,
    actualFacilityCode: null,
    isLocked: null,
    tripDays: null,
    companyId: null,
    createdDate: null,
    lastUpdatedDate: null,
    isWillCallManifest: null
    } as ManifestResource;
}


